/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2024. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import { defineStore } from 'pinia';
import MultiFactorAuthenticationService from '@/services/api/multi-factor-authentication.api-service';

const useMfaStore = defineStore('mfa', {
  state: () => ({
    mfaUrl: '',
    mfaSecret: '',
    isMFAEnabled: false,
  }),
  actions: {
    async generateMFASecret(params) {
      const res = await MultiFactorAuthenticationService.generateMFASecret(params);
      this.mfaUrl = res.mfaUrl;
      this.mfaSecret = res.mfaSecret;
    },

    async activateMFA(params) {
      await MultiFactorAuthenticationService.activateMFA(params);
    },

    async resetMFA(params) {
      await MultiFactorAuthenticationService.resetMFA(params);
    },

    async getMFAStatus() {
      const res = await MultiFactorAuthenticationService.isMFAEnabled();
      this.isMFAEnabled = res.isEnabled;
    },
  },
});

export default useMfaStore;
